/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from 'jquery'
import Vue from 'vue'
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue'
import { ServerTable } from 'vue-tables-2'
import Popper from 'popper.js'
import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'
import Tinymce from '@tinymce/tinymce-vue'
import { mapGetters } from 'vuex'
import Sticky from 'vue-sticky-directive'
import VueLazyLoad from 'vue-lazyload'

import '@/lib/chartjs'
import api from '@/api'
import store from '@/store'
import router from '@/router'

import AgentPhotoCard from './components/AgentPhotoCard'
import ApproveInsightButton from './components/ApproveInsightButton'
import Apps from './components/Apps'
import AppsLibrary from "./components/AppsLibrary"
import AppDetailHeader from './components/AppDetailHeader'
import AttendanceForm from './components/AttendanceForm'
import Autocomplete from './components/Autocomplete'
import Badge from './components/Badge'
import CalendarsMenu from './components/CalendarsMenu'
import Campaign from './components/Campaign'
import CampaignAlert from './components/CampaignAlert'
import CampaignModal from './components/CampaignModal'
import ChangeDomainName from './components/ChangeDomainName'
import CodeEditor from './components/CodeEditor'
import Confirm from './components/Confirm'
import ContactOc from './components/ContactOc'
import ContactEvp from './components/ContactEvp'
import CreateListingModal from './components/CreateListingModal'
import Dashboard from './components/dashboard/Dashboard'
import DocusignUser from './components/DocusignUser'
import Dropzone from './components/Dropzone'
import GeocoderConsole from './components/GeocoderConsole'
import GoogleChromePrompt from './components/GoogleChromePrompt'
import GuideNavbar from './components/GuideNavbar'
import Help from './components/Help'
import Hide from './components/Hide'
import InlineEditor from './components/InlineEditor'
import ListingItem from './components/ListingItem'
import ListingMediaArchiveModal from './components/ListingMediaArchiveModal'
import ListingMediaCarousel from './components/ListingMediaCarousel'
import ListingNotifyMarketingToggleButton from './components/ListingNotifyMarketingToggleButton'
import ListingTakenDownToggleButton from './components/ListingTakenDownToggleButton'
import ListingHeroContentEditor from './components/ListingHeroContentEditor'
import ListingFeaturesEditor from './components/ListingFeaturesEditor'
import ListingReimbursementButton from './components/ListingReimbursementButton'
import Login from './components/Login'
import MarkGuideAsRead from './components/MarkGuideAsRead'
import ModelActions from './components/ModelActions'
import Notes from './components/Notes'
import Notifications from './components/Notifications'
import OrgChart from './components/OrgChart'
import PageMenu from './components/PageMenu'
import Person from './components/roster/Person'
import PersonActionDropdown from './components/PersonActionDropdown'
import Project from './components/Project'
import ReconcileLeadButton from './components/ReconcileLeadButton'
import RegisterRecruitModal from './components/RegisterRecruitModal'
import Search from './components/Search'
import ShareButton from './components/ShareButton'
import Slideout from './components/Slideout'
import SupportTopics from './components/SupportTopics'
import TasksCard from './components/TasksCard'
import TasksMenu from './components/TasksMenu'
import TasksNavbar from './components/TasksNavbar'
import { ToggleButton } from 'vue-js-toggle-button'
import Testimonials from './components/Testimonials'
import ToggleSupportShowAgentExperience from './components/ToggleSupportShowAgentExperience'
import TrailCarousel from './components/TrailCarousel'
import TwoFactorAuthSettings from './components/TwoFactorAuthSettings'
import Upload from './components/Upload'
import VideoPlayer from './components/VideoPlayer'
import VideoPlayerControls from './components/VideoPlayerControls'
import Widget from './components/dashboard/Widget'
import WidgetGroup from './components/dashboard/WidgetGroup'
import WistiaLink from './components/WistiaLink'
import Wufoo from './components/Wufoo'
import GuidesCard from "./components/GuidesCard";
import FavoriteButton from "./components/reactions/FavoriteButton";

import BusinessPlanEditor from './views/BusinessPlanEditor'
import BusinessPlanHome from './views/BusinessPlanHome'
import BusinessPlanPrepwork from './views/BusinessPlanPrepwork'
import Calendar from './views/Calendar'
// import Calendars from './views/Calendars'
import CallCenter from './views/CallCenter'
import DarwinPeople from './views/DarwinPeople'
import Listing from './views/Listing'
import Listings from './views/Listings'
import Office from './views/Office'
import People from './views/People'
import ReactionGallery from './views/ReactionGallery'
import ReactionHistory from './views/ReactionHistory'
import RecruitingActivityTracker from './views/RecruitingActivityTracker'
import SettingsProfile from './views/SettingsProfile'
import SsoRedirect from './views/SsoRedirect'
import Tasks from './views/Tasks'


/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

// allow Redwood.echo to be undefined or false because Echo will term the script if empty config is given
const __echoConfig = _.get(window, 'Redwood.echo')
if (__echoConfig) (
  window.Echo = new Echo(__echoConfig)
)

import moment from 'moment'

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window._ = _
window.$ = $
window.jQuery = $
window.Popper = Popper
window.moment = moment
require('bootstrap')
let VueContentPlaceholders = require('vue-content-placeholders')

Vue.use(BootstrapVue)
Vue.use(ToastPlugin)
Vue.use(VueContentPlaceholders)
Vue.use(Sticky)
Vue.use(VueLazyLoad)

Vue.use(
  ServerTable,
  {}, // option
  false, // useVuex
  'bootstrap4' // theme
)

if (_.get(window, 'Redwood.segment.key')) {
  /* eslint-disable */
  (function() {
    var analytics = window.analytics = window.analytics || [];
    if (!analytics.initialize) {
      if (analytics.invoked) {
        window.console && console.error && console.error("Segment snippet included twice.");
      } else {
        analytics.invoked = !0;
        analytics.methods = [
          "trackSubmit",
          "trackClick",
          "trackLink",
          "trackForm",
          "pageview",
          "identify",
          "reset",
          "group",
          "track",
          "ready",
          "alias",
          "debug",
          "page",
          "once",
          "off",
          "on"
        ];
        analytics.factory = function (t) {
          return function () {
            var e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics
          }
        };
        for (var t = 0; t < analytics.methods.length; t++) {
          var e = analytics.methods[t];
          analytics[e] = analytics.factory(e)
        }
        analytics.load = function (t, e) {
          var n = document.createElement("script");
          n.type = "text/javascript";
          n.async = !0;
          n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
          var a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(n, a);
          analytics._loadOptions = e
        };
        analytics.SNIPPET_VERSION = "4.1.0";
        analytics.load(Redwood.segment.key)
        if (Redwood.segment.debug) {
          analytics.debug()
        }
        if (Redwood.identity) {
          analytics.identify(Redwood.identity.id, Redwood.identity.traits)
        }
        analytics.page()
      }
    }
  })()
  /* eslint-enable */
}

if (_.get(window, 'Redwood.debug')) {
  window.Redwood = _.merge(window.Redwood, {
    api
  })
}

const useRouter = _.get(window, 'Redwood.useRouter')

const $window = $(window)

let appConfig = {
  el: '#app',
  store,
  components: {
    // Components
    AgentPhotoCard,
    ApproveInsightButton,
    Apps,
    AppsLibrary,
    AppDetailHeader,
    AttendanceForm,
    Autocomplete,
    Badge,
    CalendarsMenu,
    Campaign,
    CampaignAlert,
    CampaignModal,
    ChangeDomainName,
    // Calendars,
    CodeEditor,
    Confirm,
    ContactOc,
    ContactEvp,
    CreateListingModal,
    Datepicker,
    DocusignUser,
    Dropzone,
    GeocoderConsole,
    GoogleChromePrompt,
    GuideNavbar,
    Help,
    Hide,
    InlineEditor,
    ListingItem,
    ListingMediaArchiveModal,
    ListingMediaCarousel,
    ListingNotifyMarketingToggleButton,
    ListingTakenDownToggleButton,
    ListingHeroContentEditor,
    ListingFeaturesEditor,
    ListingReimbursementButton,
    Login,
    MarkGuideAsRead,
    ModelActions,
    Notes,
    Notifications,
    OrgChart,
    PageMenu,
    PersonActionDropdown,
    Project,
    ReconcileLeadButton,
    RegisterRecruitModal,
    Search,
    ShareButton,
    Slideout,
    SupportTopics,
    TasksCard,
    TasksMenu,
    TasksNavbar,
    Testimonials,
    Tinymce,
    ToggleButton,
    ToggleSupportShowAgentExperience,
    TrailCarousel,
    TwoFactorAuthSettings,
    Upload,
    VideoPlayer,
    VideoPlayerControls,
    Widget,
    WidgetGroup,
    WistiaLink,
    Wufoo,

    // Views
    BusinessPlanEditor,
    BusinessPlanHome,
    BusinessPlanPrepwork,
    Calendar,
    CallCenter,
    Dashboard,
    DarwinPeople,
    Listing,
    Listings,
    Office,
    People,
    Person,
    ReactionGallery,
    ReactionHistory,
    RecruitingActivityTracker,
    SettingsProfile,
    SsoRedirect,
    Tasks,
    GuidesCard,
    FavoriteButton

  },

  computed: {
    ...mapGetters('notifications', [
      'countUnreadNotifications'
    ])
  },

  mounted () {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-has-tooltip="true"]').tooltip()
  },

  methods: {
    submitFormOnChange (e) {
      console.log(e)
      $(e.target).closest('form').submit()
    },

    showSearch () {
      $window.trigger('search.requested')
    },

    showHelp (options) {
      $window.trigger('help.requested', [options])
    },

    showCreateListing (options) {
      $window.trigger('createListing.requested', [options])
    },

    showRegisterRecruit (options) {
      $window.trigger('registerRecruit.requested', [options])
    },

    showListingMediaArchive (options) {
      $window.trigger('listingMediaArchive.requested', [options])
    },

    showRebuildTasks(options) {
      $window.trigger('rebuildTasks.requested', [options])
    },

    createNewTask (options) {
      if ($('#create-new-task:visible').length) {
        $('#create-new-task').click()
      } else {
        $window.trigger('createNewTask.requested', [options])
      }
    },

    isMacOS () {
      return navigator.userAgent.indexOf('Mac OS') !== -1
    },

    isPC () {
      return !this.isMacOS()
    },

    reload () {
      document.location.reload()
    }
  }
}

if (useRouter) {
  appConfig.router = router
}

/* eslint-disable no-new */
new Vue(appConfig)
